import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/services/api.service';
import { environment } from 'environments/environment';
import { CookieService } from 'ngx-cookie-service'
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-pnr-flight-form',
  templateUrl: './pnr-flight-form.component.html',
  styleUrls: ['./pnr-flight-form.component.css']
})
export class PnrFlightFormComponent implements OnInit {
  sessionid: any;
  ismobile;
  baflight : boolean = false;
  currenturl;
  environtment = environment
  constructor(private router: Router,public dialog: MatDialog, private datepipe:DatePipe, private devicedetails: DeviceDetectorService, private apiservice : ApiService, private route: ActivatedRoute,private cookieService: CookieService) {
    this.ismobile = this.devicedetails.isMobile();
    this.currenturl = this.router.url;
    this.checkbaflight()
    const devicetype = this.devicedetails.isTablet() ? 'Tablet' : this.devicedetails.isMobile() ? 'Mobile' : this.devicedetails.isDesktop() ? 'Desktop' : 'Others';
    this.devicetype = devicetype
    this.showcontent = this.isPortrait && devicetype == 'Mobile' ? true : !this.isPortrait && devicetype == 'Mobile' ? false : true
   }
  flightNo: any = '';
  ref: MatDialogRef<any>;
  ref1: MatDialogRef<any>;
  @ViewChild("DialogComponent", { read: TemplateRef, static: false }) DialogComponent: TemplateRef<any>;
  @ViewChild("notificationComponent", { read: TemplateRef, static: false }) notificationComponent: TemplateRef<any>;
  @ViewChild("nopermission", { read: TemplateRef, static: false }) nopermission: TemplateRef<any>;
  @ViewChild("iOSpopup", { read: TemplateRef, static: false }) iOSpopup: TemplateRef<any>;
  datamessage = '';
  spinner:boolean = false;
  isPortrait:boolean;
  SearchLoader:boolean = false;
  nodatamessage:boolean = false;
  dataarray = [];
  allflightdata = [];
  langconfig;
  devicetype;
  showcontent;
  language;
  routed:boolean = false;
  typeclicked;
  value;
  dialogopened:boolean = false;
  gsearch:boolean = false;
  userStop$: Subject<boolean> = new Subject<boolean>();
  apiTrigger$: Subject<boolean> = new Subject<any>();
  showdialogbox:boolean = false;
  nogatemessage:boolean = false;
  datajson = require('../../Jsons/'+this.environtment.project+'data.json')
  dummydatahome=this.datajson['dummydatahome'];
  socialmedia= this.datajson['socialmedia'];
  terminal = this.datajson['terminal'];
  Welcometext = this.datajson['Welcometext'];
  stepslist = [
    'Tap the "Share" icon located in Browser.',
    'Select "Add to Home Screen" from the options.',
    'Tap "Add" or "Ok" to complete the process.',
    'Access Smart Boarding from home screen.',
    'Enable notifications.',
  ]
  
  ngOnInit() {
    if(sessionStorage.getItem('sessionId')){
      sessionStorage.removeItem('sessionId');
    }
    this.checkbaflight()
    sessionStorage.removeItem('sessionId');
    this.checkOrientation();
    if(sessionStorage.getItem('searchedFlight') && this.baflight){
      this.flightNo = sessionStorage.getItem('searchedFlight')
      // this.searchflightdata(this.flightNo, '', 's')
    }else{
      this.flightNo = '';
    }
    this.apiservice.language.subscribe((res)=>{
      const langcode = res.code
      this.langconfig = langcode == 'En' ? require("../../Language/En-us.json") : require("../../Language/It-us.json")
    })
    this.checklanguage();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkOrientation();
  }

  private checkOrientation(): void {
    this.isPortrait = window.innerHeight > window.innerWidth ? true : false;
    const devicetype = this.devicedetails.isTablet() ? 'Tablet' : this.devicedetails.isMobile() ? 'Mobile' : this.devicedetails.isDesktop() ? 'Desktop' : 'Others';
    this.devicetype = devicetype
    this.showcontent = this.isPortrait && devicetype == 'Mobile' ? true : !this.isPortrait && devicetype == 'Mobile' ? false : true
  }

  closedialog(){
    this.ref.close();
  }


  checklanguage(){
    this.apiservice.language.subscribe(res=>{
      this.language = res.code
    })
  }
  sendToPNR2() {
    if(this.flightNo){
      this.flightNo = this.flightNo.toUpperCase()
      this.spinner = true;
      this.apiservice.gates_api(this.flightNo).subscribe(response => {

          this.flightNo = response.data[0].gate_no
          let responsedata = response.data.filter(item => item !== response.data[1])
          this.apiservice.setSharedData(responsedata);
          this.opengate(this.flightNo, '');
      },(error)=>{
          this.spinner = false;
          this.opendialogbox()
        })      
    }
  }
  source;
  medium;
  opengate(d, a?, s?){
    if(!a){
      this.gsearch = false;
      const devicedetails = this.devicedetails.getDeviceInfo();
      const deviceres = window.innerHeight + '*' + window.innerWidth;
      const devicetype = this.devicedetails.isTablet() ? 'Tablet' : this.devicedetails.isMobile() ? 'Mobile' : this.devicedetails.isDesktop() ? 'Desktop' : 'Others';
      this.devicetype = devicetype
      sessionStorage.setItem('fromdevice',this.devicetype);
    
      if(this.route.snapshot.queryParams['source']){
        this.source = 'bahome';
        sessionStorage.setItem('fromsource',this.source);
        sessionStorage.setItem('source', this.source);
      }else {
        this.source = 'bahome';
        sessionStorage.setItem('fromsource',this.source);
        sessionStorage.setItem('source', this.source);
      }
      if(this.route.snapshot.queryParams['medium']){
        this.medium = this.route.snapshot.queryParams['medium'];
        sessionStorage.setItem('medium',this.medium);
      }else if(sessionStorage.getItem('medium')){
        this.medium = sessionStorage.getItem('medium');
      }else{
        this.medium = 'weblink'
        sessionStorage.setItem('medium',this.medium);
      }
      const param = {
        browser_name : devicedetails.browser,
        browser_version: devicedetails.browser_version,
        device_name: devicedetails.device,
        os_name: devicedetails.os,
        os_version: devicedetails.os_version,
        user_agent: devicedetails.userAgent,
        resolution: deviceres,
        device_type: devicetype,
        gate : d.gate,
        device: this.devicetype ? this.devicetype : 'Undefined',
        source: this.source ? this.source : 'Undefined',
        medium: this.medium ? this.medium : 'Undefined',
      }
      this.spinner = true;
      this.apiservice.gates_api(d.gate).subscribe(response => {
        let flightcode = '';
            if(this.flightNo.includes('BA ')){
              const flightcodes = this.flightNo.split(' ')
              flightcode = flightcodes[0];
            }
            this.flightNo = response.data[0].gate_no
            let responsedata = response.data.filter(item => item !== response.data[1])
              this.apiservice.setSharedData(responsedata);
              this.apiservice.getsession(param).subscribe(res =>{
                  if(res.id){
                    this.sessionid = res.id
                    this.spinner = false;
                    this.flightNo = this.flightNo;
                    this.router.navigate(['/pax'],{ queryParams: { gateno: d.gate, pax_view_session: this.sessionid } })
                    this.apiservice.setsessionId('sessionId', this.sessionid,2);
                  }
                  this.spinner = false;
                },(error)=>{
                  this.spinner = false;
                })
          },(error)=>{
            this.spinner = false;
            this.opendialogbox()
      })   
    }else{
      if(s){
        this.searchflightdata(d, '', d);
      }else{
        this.searchflightdata(d, '');
      }
    }
  }


  searchflightdata(fdata, a?, s?){
    this.nogatemessage = false;
    this.showdialogbox = false;
    if(!fdata){
      this.showdialogbox = false;
    }
    this.apiservice.setsearchedflightdta(null);
    if(a){
      this.nodatamessage = false;
      this.dataarray = [];
      const flightdata = fdata.toUpperCase()
      const params = {
        fdata: flightdata
      }
      if(s){
        params['search_by'] = 'flight',
        params['airlines'] = ['BA']
      }
      if(fdata.length >0){
        this.SearchLoader = true;
        this.gsearch = true;
        this.userStop$.next(true);
        this.apiTrigger$
        .pipe(
          switchMap(() => this.apiservice.Autosearchapi(params)),
          takeUntil(this.userStop$)
        )
        .subscribe(
          response => {
            this.showdialogbox = true;
            this.userStop$.next(true);
            this.dataarray = [];
            this.nodatamessage = response.data.length > 0 ? false : true;
            const cutoffdata = response.data.slice(0, 10);
            this.dataarray = cutoffdata;
            this.SearchLoader = false;
          },
          error => {
            this.nodatamessage = true;
            this.SearchLoader = false;
          },
        );
        this.apiTrigger$.next(flightdata);
      }
    }else{
      this.showdialogbox = false;
      this.nodatamessage = false;
      this.allflightdata = [];
      let flightdata;
      if(!s){
        flightdata = fdata.toUpperCase();
      }else{
        flightdata = fdata.flight.toUpperCase();
      }
      const params = {
        fdata: flightdata
      }
      if(s){
        params['search_by'] = 'flight',
        params['airlines'] = s.flight_pk
      }
        this.SearchLoader = true;
        this.gsearch = false
        this.dataarray = null
        this.apiservice.clicksearchapi(params).subscribe(response => {
          this.userStop$.next(true);
          if(s){
            response.data[0]['flight_pk'] = s.flight_pk
          }
          this.apiservice.setsearchedflightdta(response);
          if(response){
            this.nodatamessage = response.data.length > 0 ? false : true;
            this.allflightdata = response.data;
            if(s){
              this.flightNo = this.allflightdata[0].flight
            }else{
              this.flightNo = this.allflightdata[0].gate;
            }
            sessionStorage.setItem('searchedFlight', this.flightNo.toUpperCase())
            this.SearchLoader = false;
          }
        },(error)=>{
          this.gsearch = false;
          this.nodatamessage = true;
          this.SearchLoader = false;
        })
    }
  }


  openflightgate(){
    let flightdataresponce = this.apiservice.getflightshareddata();
    const details = flightdataresponce.data[0];
    const params = {
      fdata: details.flight,
      search_by: 'flight',
      airlines: details.flight_pk
    }
      this.apiservice.clicksearchapi(params).subscribe(response => {
        if(response){
          response.data[0]['flight_pk'] = details.flight_pk
          this.apiservice.setsearchedflightdta(response)
          flightdataresponce = this.apiservice.getflightshareddata();
          if(flightdataresponce){
            this.showdialogbox = true;
            if(flightdataresponce){
              this.allflightdata = flightdataresponce.data;
            }
            if(this.allflightdata[0] && this.allflightdata[0].gate){
              this.opengate(this.allflightdata[0], '')
            }else{
              this.nodatamessage = true;
              this.nogatemessage = true;
            }
          }
        }
      })
  }

  checkbaflight(){
    if(this.currenturl.includes('/bahome')){
      this.baflight = true;
      sessionStorage.setItem('bahome', 'true');
    }else if(this.currenturl == '/' && (sessionStorage.getItem('bahome'))){
      this.baflight = true;
    }else if(!this.currenturl.includes('/bahome') && ( sessionStorage.getItem('bahome'))){ 
      this.baflight = true;
    }
  }

  medialinkclicked(data){
    const link = data ? data.link : 'https://www.britishairways.com/travel/managebooking/public/en_in'
    window.open(
      link,
      "_blank",
    );
  } 

  notificationicon() {
    try {
        this.value = localStorage.getItem('notification');
        if (typeof Notification !== 'undefined') {
            if ((Notification.permission === 'denied' && localStorage.getItem('subvalue')) || 
                (Notification.permission === 'default' && localStorage.getItem('subvalue'))) {
                this.apiservice.unsubvalue();
            }
            return this.value === 'true' && Notification.permission === 'granted'
                ? '/assets/images/svg/notificationiconADR.svg'
                : '/assets/images/svg/nonotificationADR.svg';
        } else {
            console.warn('Notification API is not supported in this environment.');
            return '/assets/images/svg/nonotificationADR.svg';
        }
    } catch (error) {
        console.log(error);
    }
  }


  notificationiconclick(){
    if(this.value == 'true'){
      if('Notification' in window){ 
        if(Notification.permission == 'granted'){
          this.savesubscriptoin();
        }else if(Notification.permission == 'denied'){
          this.dialogopened = true;
          this.ref1 = this.dialog.open(this.nopermission)
        }else if(Notification.permission == 'default'){
          this.apiservice.setnotification('false')
          this.dialogopened = true;
          this.ref = this.dialog.open(this.notificationComponent)
        }
      }
    }else if(!localStorage.getItem('subvalue')){
      if(!this.dialogopened){
        if('Notification' in window){
          if(Notification.permission == 'granted' || Notification.permission == 'default'){
            this.dialogopened = true;
            this.ref = this.dialog.open(this.notificationComponent)
          }else if(Notification.permission == 'denied'){
            this.dialogopened = true;
            this.ref1 = this.dialog.open(this.nopermission)
          }
        }else{
          console.log('no notification show to click on the share');
          this.dialogopened = true;
          this.ref1 = this.dialog.open(this.iOSpopup)
        }
      }
    }else if(localStorage.getItem('subvalue') && Notification.permission == 'default'){
      Notification.requestPermission().then((res)=>{
        if(res == 'granted'){
          this.apiservice.setnotification('false');
          this.savesubscriptoin();
        }else if(res == 'default'){
          Notification.requestPermission().then(res=>{
            if(res == 'granted'){
              this.apiservice.setnotification('false');
              this.savesubscriptoin();
            }
          })
        }
      })
    }else if(Notification.permission == 'granted'){
      this.savesubscriptoin();
    }else if(Notification.permission == 'denied'){
      if(!this.dialogopened){
        if(this.devicedetails.os != 'iOS'){ // checking notification in the window
          if(Notification.permission == 'denied'){ // condition to handle to show if notifications are denied
            this.dialogopened = true;
            this.ref1 = this.dialog.open(this.nopermission)
          }
        }else{
          this.dialogopened = true;
          this.ref1 = this.dialog.open(this.iOSpopup)
        }
      }
    }
  }


  closedialog1(value){
    if(!value){
      this.dialogopened = false;
      this.ref.close();
    }else{
      this.dialogopened = false;
      const subvalue = localStorage.getItem('subvalue');
      const sub = JSON.parse(subvalue);
      if(!sub){
        this.getSubscription()
      }else if(sub && Notification.permission == 'granted'){
        this.savesubscriptoin();
      }else if(sub && Notification.permission == 'default'){
        Notification.requestPermission().then((res)=>{
          if(res == 'granted'){
            this.savesubscriptoin();
          }
        })
      }
      this.ref.close();
    }
  }

  getSubscription(){
    this.apiservice.getsubscriptionvalue()
  }

  savesubscriptoin(){
    this.apiservice.callsavesubscription();
  }


  closedialogss(s?){
    if(s){
      this.showdialogbox = this.showdialogbox
    }else{
      if(this.showdialogbox){
        this.showdialogbox = false;
      }
    }

  }

    
  closedialog2(){
    this.dialogopened = false;
    this.ref1.close();
  }


  opentopagenavigate(item?){
    if(!this.showdialogbox){
      this.flightNo = sessionStorage.getItem('searchedFlight')
      if(item && item.toroute){
        this.router.navigate(['/services'],{ queryParams: {service: item.toroute } })
      }
    }
  }

  setflightdate(date){
    const today = this.datepipe.transform(new Date);
    const tomorrowDate = new Date();
    tomorrowDate.setDate(tomorrowDate.getDate() + 1);
    const tommorow = this.datepipe.transform(tomorrowDate);
    const value = this.datepipe.transform(date);
    if(today == value){
      return 'Today';
    }else if(tommorow == value){
      return 'Tomorrow'
    }else{
      return this.datepipe.transform(date);
    }
  }
  redtext:boolean = false;
  checkvalue(flight){
    if(flight){
      const std = this.datepipe.transform(flight.std, "HH:mm");
      const etd = this.datepipe.transform(flight.etd, "HH:mm");
      if(flight.etd){
        this.redtext = std == etd ? false : true;
        return std == etd ? false : true;
      }else{
        return false;
      }
    }
  }
  opendialogbox(){
    this.ref = this.dialog.open(this.DialogComponent);
  }
}
